import { useContext, useEffect } from 'react'
// // material
import { Box, Grid } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import { useLocation } from 'react-router-dom'
import CreateGuaranteeHeader from 'pages/dashboard/headers/CreateGuaranteeHeader'
import { GlobalInfoContext } from 'contexts/GlobalStateContext'
import Page from 'components/Page'
import PaperGuarantee from './sections/forms/PaperGuarantee'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    width: '100%',
    paddingBottom: '2rem',
    justifyContent: 'space-between',
    textAlign: 'right',
    fontFamily: 'EH Normal',
    fontWeight: 700,
    fontSize: 20
  }
})

export const PaperGuaranteeCreation = () => {
  const classes = useStyles()
  const location = useLocation()

  const { setReqInfo } = useContext(GlobalInfoContext)

  useEffect(() => {
    const appOrBene = location.pathname.includes('applicant') ? 'applicant' : 'beneficiary'
    setReqInfo({ initiatedBy: appOrBene })
  }, [location])

  return (
    <Page sx={{ margin: '0 24px 0 18px' }}>
      <CreateGuaranteeHeader label="Create New Paper Guarantee Request" />
      <Box sx={{ flexGrow: 1, ...classes }}>
        <Grid>
          <PaperGuarantee />
        </Grid>
      </Box>
    </Page>
  )
}

export default PaperGuaranteeCreation
